import React from "react";
import { aiImageList } from "data/aiImageList";
import { aiProductList } from "data/aiProductList";
import ServiceTitleVisionFlow from "components/ServiceTitleVisionFlow";
import GalleryBox from "components/GalleryBox";
import MovingGallary from "components/MovingGallary";
import ServiceSwiper from "components/ServiceSwiper";

export default function ServiceGenAI() {
  return (
    <>
      <div className="app-services">
        <section className="service-ai-wrap">
          <ServiceTitleVisionFlow />
          <GalleryBox imageList={aiImageList} />
          <MovingGallary />
          <ServiceSwiper productList={aiProductList} />
        </section>
      </div>
    </>
  );
}
